var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{staticClass:"grey--text text--lighten-1",attrs:{"depressed":"","text":""},on:{"click":function($event){return _vm.loadVersionHistory()}}},[_vm._v(" v"+_vm._s(_vm.version)+" "+_vm._s(_vm.errorStatus)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }